module.exports = __webpack_public_path__ + "static/contract-concretion-147d40a348927a06c1c7b7c2c54b0161.png";